import { createSelector } from '@reduxjs/toolkit';
import moment from 'moment';
import { State } from './types';
import { RootState } from '../root-reducer';

export const rootSelector = (state: RootState): State => state.APIAuth;

export const statusSelector = createSelector(rootSelector, (state) => state.status);
export const errorSelector = createSelector(rootSelector, (state) => state.error);
export const dataSelector = createSelector(rootSelector, (state) => state.data);

export const isAuthSelector = createSelector(rootSelector, (state): boolean => {
  return !!state?.data?.expirationDate && moment().isBefore(state?.data?.expirationDate, 'second');
});
export const userNameSelector = createSelector(rootSelector, (state) => state.userName);
export const isLoginExpiredSelector = createSelector(rootSelector, (state) => !!state.isLoginExpired);
